import { render, staticRenderFns } from "./BotonProcesoTabCapacitacion.vue?vue&type=template&id=34095279&"
import script from "./BotonProcesoTabCapacitacion.vue?vue&type=script&lang=js&"
export * from "./BotonProcesoTabCapacitacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports